import { PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/portal';
import { paymentAmountFormat } from '@willow/shared-web';

import { AlertWrapper } from './AlertWrapper';

export const ActiveWorkoutPlanAlert = ({
  activeWorkoutPlan,
  totalAmountDue,
}: {
  activeWorkoutPlan: PortalWorkoutPlanFragment | undefined;
  totalAmountDue: number;
}) => {
  if (!activeWorkoutPlan) return null;

  return (
    <>
      {activeWorkoutPlan.__typename === 'FlexModificationWorkoutPlan' && (
        <AlertWrapper
          title="Active trial flex modification in place"
          subtitle={`${paymentAmountFormat(totalAmountDue)} payment will reinstate the loan in full`}
          level="ERROR"
        />
      )}

      {activeWorkoutPlan.__typename === 'ForbearanceWorkoutPlan' && (
        <AlertWrapper
          title="Active forbearance in place"
          subtitle={`${paymentAmountFormat(totalAmountDue)} payment will reinstate the loan in full`}
          level="ERROR"
        />
      )}
    </>
  );
};
